import { create } from "zustand";
import { setupAxiosAuthInterceptor } from "utils/axios";
import { JWT_TOKEN_KEY } from "utils/constants";

type AuthStore = {
  jwt: string | null;
  setJwt(jwt: string | null): void;
  resetJwt(): void;
};

export default create<AuthStore>(
  (set, get): AuthStore => ({
    jwt: localStorage.getItem(JWT_TOKEN_KEY) || null,
    resetJwt() {
      get().setJwt(null);
    },
    setJwt(jwt) {
      if (jwt) {
        localStorage.setItem(JWT_TOKEN_KEY, jwt);
        set({ jwt });
        setupAxiosAuthInterceptor();
      } else {
        localStorage.removeItem(JWT_TOKEN_KEY);
        set({ jwt: null });
        setupAxiosAuthInterceptor();
      }
    },
  }),
);
